import React from "react";
import ReactCountryFlag from "react-country-flag";
import { CURRENCY_FLAG_OVERRIDES } from "../../constants/enums";
import type { FieldOption } from "../../types/components/dynamicForms";

/**
 * Currency option label with a flag. formatOptionLabel only receives the
 * option, so the selected country is bound in: the flag is the country's,
 * unless the currency has an override (EUR → EU).
 */
const RenderCurrencyOption = (countryIso: string) => (option: FieldOption): React.ReactNode => (
  <span className="bwp-country-option">
    <ReactCountryFlag
      countryCode={CURRENCY_FLAG_OVERRIDES[option.value] ?? countryIso}
      className="emojiFlag flag mr-8"
      style={{
        fontSize: "24px",
        lineHeight: "24px",
      }}
      aria-hidden
    />
    <span className="bwp-currency-option__code">{option.value}</span>
    <span className="bwp-currency-option__name">{option.label}</span>
  </span>
);

export default RenderCurrencyOption;